import config from "../config";
import { createGtm } from "@gtm-support/vue-gtm";
import VueSplide from "@splidejs/vue-splide";

declare global {
  interface Window {
    analytics: any;
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  console.log(config("version"));
  const router = useRouter();

  nuxtApp.vueApp.use(VueSplide);
  nuxtApp.vueApp.use(
    createGtm({
      id:
        config("isProduction").toString() == "true"
          ? "GTM-K7XJHFM"
          : "GTM-5HQWMMB", // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
      defer: true, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
      compatibility: true, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
      enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
      debug: config("isProduction").toString() == "true" ? false : true, // Whether or not display console logs debugs (optional)
      loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
      vueRouter: router, // Pass the router instance to automatically sync with router (optional)
      trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
    }),
  );
});
